import React from 'react';
import { classes } from './WeeklyDatepicker.st.css';
import { WeeklyDatePicker, DatePickerFirstDayOfWeek } from 'wix-ui-tpa/cssVars';
import {
  isSameDay,
  getLocalDateTimeEndOfDay,
  getLocalDateTimeStartOfDay,
} from '@wix/bookings-catalog-calendar-viewer-utils/dateAndTime';
import { useDailyAgendaActions } from '../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import { useWidgetViewModel } from '../../../components/DailyAgenda/hooks/useWidgetViewModel';
import { WeeklyDatepickerDataHooks } from './const';

export interface WeeklyDatepickerProps {}

export const WeeklyDatepicker: React.FC<WeeklyDatepickerProps> = () => {
  const { onWeekChange, onDaySelected } = useDailyAgendaActions();
  const { datePickerViewModel } = useWidgetViewModel();
  const {
    selectedDate,
    availableDates,
    firstDayOfTheWeek = 0,
  } = datePickerViewModel || {};

  if (!selectedDate) {
    return null;
  }

  const filterDates = (date: Date) => {
    return !!availableDates?.find((availableDate) =>
      isSameDay(new Date(date), new Date(availableDate)),
    );
  };

  return (
    <div className={classes.root} data-hook={WeeklyDatepickerDataHooks.Main}>
      <WeeklyDatePicker
        data-hook={WeeklyDatepickerDataHooks.WeeklyDatepicker}
        value={new Date(selectedDate)}
        onDisplayedWeekChange={(week) =>
          onWeekChange({
            from: getLocalDateTimeStartOfDay(week.startOfWeek),
            to: getLocalDateTimeEndOfDay(week.endOfWeek),
          })
        }
        firstDayOfWeek={firstDayOfTheWeek as DatePickerFirstDayOfWeek}
        filterDate={filterDates}
        removeOuterPadding
        onChange={(day: Date) => {
          onDaySelected(day.toISOString());
        }}
      />
    </div>
  );
};
